import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { PlayerService } from 'src/app/shared/player.service';
import { PlayerTagViewModel } from '../../models/PlayerModels';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-add-tag-dialog',
    templateUrl: './add-tag-dialog.component.html',
    styleUrls: ['./add-tag-dialog.component.css'],
    imports: [MatDialogTitle, MatIcon, CdkScrollable, MatDialogContent, MatSelectionList, MatListOption, NgClass, MatDialogActions, MatButton, MatDialogClose]
})
export class AddTagDialogComponent implements OnInit {

  
  @ViewChild('tags') tagSelectionList: MatSelectionList;

  Tags: PlayerTagViewModel[];

  constructor(private playerService: PlayerService,    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log(this.data);
    this.playerService.getAvailableTags().subscribe(tags=>{
      console.log(tags);
      this.Tags=tags as PlayerTagViewModel[];
    });
  }

  save(){
    
      console.log(this.tagSelectionList.selectedOptions.selected.map(s => s.value));
      this.tagSelectionList.selectedOptions.selected.map(s => s.value).forEach(tagid=>{
        this.playerService.addTagToPlayer(this.data.PlayerId, tagid).subscribe(result=>{
          console.log(result);
        });
      });
    
  }

}

